import {createFileRoute, redirect} from "@tanstack/react-router";
import {taskSearchValidator} from "./-model";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/ottosync-task-manager")({
    beforeLoad: () => {throw redirect({href: "/a/data-pipeline/history"});},
    validateSearch: (search) => taskSearchValidator.parse(search),
    loader: ({context}) => ({accessToken: context.authenticationStatus.accessToken, intellsysBaseUrl: context.intellsysBaseUrl}),
    component: RouteComponent,
});
